<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="header-left">
                <span class="header-project">{{ projectTitle }}</span>
                <span class="header-divider">/</span>
                <span class="header-sub">中标通知书</span>
            </div>
        </div>

        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="标段名称:">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" style="width: 200px;">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="action-buttons">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>

                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
<!--                <el-table-column prop="awardNoticeCode" label="通知书编号" show-overflow-tooltip />-->
                <el-table-column prop="bidders" label="中标人" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bidders && scope.row.bidders.length > 0">
                            {{scope.row.bidders.map(b => b.winBidderName).join('、')}}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="noticeType" label="通知类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.noticeType === 1">中标通知书</span>
                        <span v-else-if="scope.row.noticeType === 2">中标结果通知书</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bidders" label="中标金额" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bidders && scope.row.bidders.length > 0">
                            {{scope.row.bidders.map(b => b.bidAmount).join('、')}}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 0" size="small" type="info">暂存</el-tag>
                        <el-tag v-else-if="scope.row.status === 1" size="small" type="warning">提交</el-tag>
                        <el-tag v-else-if="scope.row.status === 9" size="small" type="success">发布</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 查看弹窗 -->
        <el-dialog title="查看中标通知书" :visible.sync="addDialogVisible" width="1000px"
            :before-close="handleCloseAddDialog" :append-to-body="true" class="add-notification-dialog">

            <!-- 查看模式：只读详情卡片 -->
            <div class="detail-view">
                <div class="detail-card">
                    <div class="detail-card__title">
                        <i class="el-icon-info"></i>基本信息
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="detail-item"><label>标段名称</label><span>{{ addForm.bidSectionName || '-' }}</span></div>
<!--                            <div class="detail-item"><label>通知书编号</label><span>{{ addForm.awardNoticeCode || '-' }}</span></div>-->
                            <div class="detail-item"><label>价款形式</label><span>{{ getPriceFormText(addForm.priceFormCode) }}</span></div>
                        </el-col>
                        <el-col :span="12">
                            <div class="detail-item"><label>通知书类型</label><span>{{ addForm.noticeType === 1 ? '中标通知书' : '中标结果通知书' }}</span></div>
                            <div class="detail-item"><label>{{ bidderLabel }}</label><span>{{ bidderTableData.map(b => b.winBidderName).filter(Boolean).join('、') || '-' }}</span></div>
                        </el-col>
                    </el-row>
                </div>
                <div class="detail-card" v-if="bidderTableData.length > 0">
                    <div class="detail-card__title">
                        <i class="el-icon-user"></i>{{ bidderLabel }}明细
                    </div>
                    <el-table :data="bidderTableData" border stripe size="small" style="width:100%">
                        <el-table-column :label="bidderLabel" min-width="160">
                            <template slot-scope="scope">{{ scope.row.winBidderName || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="中标金额" width="150"><template slot-scope="scope">{{ scope.row.bidAmount || '-' }}</template></el-table-column>
                        <el-table-column label="单位" width="80"><template slot-scope="scope">{{ getPriceUnitText(scope.row.priceUnit) }}</template></el-table-column>
                        <el-table-column label="费率/其他" width="140"><template slot-scope="scope">{{ scope.row.otherBidPrice || '-' }}</template></el-table-column>
                    </el-table>
                </div>
                <div class="detail-card">
                    <div class="detail-card__title">
                        <i class="el-icon-document"></i>通知书内容
                    </div>
                    <div class="detail-text">{{ addForm.awardContent || '-' }}</div>
                </div>
                <div class="detail-card">
                    <div class="detail-card__title">
                        <i class="el-icon-paperclip"></i>附件信息
                    </div>
                    <div v-if="fileList.length > 0" class="detail-file-table">
                        <el-table :data="fileList" border stripe size="small" style="width:100%">
                            <el-table-column type="index" label="#" width="50" align="center" />
                            <el-table-column prop="name" label="文件名称" min-width="220" show-overflow-tooltip />
                            <el-table-column prop="fileExtension" label="类型" width="80" align="center">
                                <template slot-scope="scope"><el-tag size="mini" type="info">{{ scope.row.fileExtension || '-' }}</el-tag></template>
                            </el-table-column>
                            <el-table-column label="大小" width="100" align="center">
                                <template slot-scope="scope">{{ formatFileSize(scope.row.size) }}</template>
                            </el-table-column>
                            <el-table-column label="操作" width="80" align="center">
                                <template slot-scope="scope"><el-button type="text" size="small" @click="handleFileDownload(scope.row)">下载</el-button></template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="detail-empty">暂无附件</div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAddDialog">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { getFileList } from '@/api/modules/base'
import { awardNoticeBidSectionList, awardNoticeBidders, awardNoticeDetail, bidderAwardNoticeList } from '@/api/modules/winBulletin'

export default {
    components: {
    },
    name: 'BidResultNotification',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            addDialogVisible: false,
            loadingBidders: false,
            searchForm: {
                bidSectionName: ''
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            addForm: {
                bidSection: '',
                bidSectionName: '',
                noticeType: 1,
                awardNoticeCode: '',
                winningBidder: [],
                priceFormCode: 1,
                awardContent: '',
                fileGuid: ''
            },
            fileList: [],
            bidderTableData: [],
            sectionOptions: [],
            bidderOptions: []
        }
    },
    computed: {
        dialogTitle() {
            return '查看结果通知书'
        },
        bidderLabel() {
            return this.addForm.noticeType === 1 ? '中标人' : '未中标人'
        }
    },
    mounted() {
        this.loadData()
        this.getProjectInfo()
    },
    methods: {
        async loadData() {
            this.loading = true
            try {
                await this.fetchAwardNoticeList()
            } finally {
                this.loading = false
            }
        },
        async fetchAwardNoticeList() {
            try {
                const res = await bidderAwardNoticeList({
                    projectCode: this.projectCode,
                    bidSectionName: this.searchForm.bidSectionName,
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                })
                if (res.code == 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('获取列表失败:', error)
                this.$message.error('获取列表失败')
            }
        },
        async loadSectionList() {
            try {
                const res = await awardNoticeBidSectionList({
                    projectCode: this.projectCode
                })
                if (res.code == 200) {
                    this.sectionOptions = res.data || []
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('获取标段列表失败:', error)
                this.$message.error('获取标段列表失败')
            }
        },
        async loadBidderList(bidSectionCode) {
            if (!bidSectionCode) return
            this.loadingBidders = true
            try {
                const res = await awardNoticeBidders({
                    bidSectionCode: bidSectionCode
                })
                if (res.code == 200) {
                    this.bidderOptions = res.data || []
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('获取中标人信息失败:', error)
                this.$message.error('获取中标人信息失败')
            } finally {
                this.loadingBidders = false
            }
        },
        handleBack() {
            this.$router.go(-1)
        },
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        handleCloseAddDialog() {
            this.addDialogVisible = false
            this.resetAddForm()
        },
        resetAddForm() {
            this.addForm = {
                bidSection: '',
                bidSectionName: '',
                noticeType: 1,
                awardNoticeCode: '',
                winningBidder: [],
                priceFormCode: 1,
                awardContent: '',
                fileGuid: ''
            }
            this.fileList = []
            this.bidderTableData = []
            this.bidderOptions = []
        },
        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return '-'
            const k = 1024
            const sizes = ['B', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
        },
        getPriceUnitText(unit) {
            const unitMap = { 0: '元', 1: '万元', 2: '%' }
            return unitMap[unit] || '-'
        },
        getPriceFormText(code) {
            const map = { 1: '总价', 2: '单价', 3: '费率', 9: '其他' }
            return map[code] || '-'
        },
        handleFileDownload(file) {
            const fileUrl = file.filePath || file.fileUrl
            if (!fileUrl) {
                this.$message.warning('文件下载地址不存在')
                return
            }
            window.open(fileUrl, '_blank')
        },
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },
        async handleView(row) {
            await this.awardNoticeDetail(row)
        },
        async awardNoticeDetail(row) {
            await this.loadSectionList()
            try {
                const res = await awardNoticeDetail({ awardNoticeCode: row.awardNoticeCode })
                if (res.code == 200) {
                    const data = res.data
                    if (data.bidSectionCode) {
                        await this.loadBidderList(data.bidSectionCode)
                    }
                    if (data.bidders && data.bidders.length > 0) {
                        const existingCodes = new Set(this.bidderOptions.map(o => o.bidderCode))
                        data.bidders.forEach(b => {
                            if (!existingCodes.has(b.winBidderGuid)) {
                                this.bidderOptions.push({
                                    bidderCode: b.winBidderGuid,
                                    bidderName: b.winBidderName || '',
                                    bidderOrgCode: b.winBidderUserId || ''
                                })
                            }
                        })
                    }
                    this.addForm = {
                        bidSection: data.bidSectionCode || '',
                        bidSectionName: data.bidSectionName || '',
                        noticeType: data.noticeType || 1,
                        awardNoticeCode: data.awardNoticeCode || '',
                        winningBidder: data.bidders ? data.bidders.map(b => b.winBidderGuid) : [],
                        priceFormCode: data.priceFormCode != null ? data.priceFormCode : 1,
                        awardContent: data.awardContent || '',
                        fileGuid: data.fileGuid || ''
                    }
                    this.bidderTableData = data.bidders ? data.bidders.map(bidder => ({
                        winBidderGuid: bidder.winBidderGuid,
                        winBidderName: bidder.winBidderName || '',
                        bidAmount: bidder.bidAmount || '',
                        priceUnit: bidder.priceUnit != null ? bidder.priceUnit : 0,
                        otherBidPrice: bidder.otherBidPrice || ''
                    })) : []
                    this.addDialogVisible = true
                    if (data.fileGuid) {
                        this.getFileList(data.fileGuid)
                    }
                } else {
                    this.$message.error(res.msg || '获取详情失败')
                }
            } catch (error) {
                console.error('获取详情失败:', error)
                this.$message.error('获取详情失败')
            }
        },
        async getFileList(fileGuid) {
            if (!fileGuid) return
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    this.fileList = res.data.map(file => ({
                        name: file.fileName,
                        size: file.fileSize,
                        uploading: false,
                        uploaded: true,
                        progress: 100,
                        fileGuid: file.fileId,
                        uploadFileId: file.fileId,
                        filePath: file.fileUrl,
                        fileUrl: file.fileUrl,
                        fileExtension: file.fileExtension
                    }))
                } else if (res.code === 200) {
                    this.fileList = []
                }
            } catch (error) {
                console.error('获取附件列表失败:', error)
            }
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
    },
    watch: {
        'addForm.priceFormCode': {
            handler(newVal) {
                const unitMap = { 1: 0, 2: 1, 3: 2, 9: 0 }
                const defaultUnit = unitMap[newVal] !== undefined ? unitMap[newVal] : 0
                if (this.bidderTableData.length > 0) {
                    this.bidderTableData.forEach(item => {
                        item.priceUnit = defaultUnit
                    })
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    padding: 0 0 20px;
    background: #f5f6f8;
    min-height: calc(100vh - 64px);
}

.page-header {
    background: #fff;
    border-radius: 8px;
    padding: 18px 24px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e8ecf1;

    .header-left { display: flex; align-items: center; gap: 10px; }
    .header-project { font-size: 15px; font-weight: 500; color: #8c939d; }
    .header-divider { color: #d0d4da; font-size: 16px; font-weight: 300; }
    .header-sub { font-size: 17px; font-weight: 700; color: #1d2b3a; }
}

.search-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    border: 1px solid #ebeef5;

    .search-form { display: flex; align-items: center; }
    .search-form .el-form-item { margin-bottom: 0; margin-right: 8px; }
    .action-buttons { display: flex; gap: 10px; flex-shrink: 0; }
}

.table-section {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #ebeef5;
    margin-bottom: 12px;
}

.data-table {
    /deep/ th {
        background: #fafbfc !important;
        color: #303133 !important;
        font-weight: 600 !important;
        font-size: 13px;
        border-bottom: 1px solid #ebeef5 !important;
        padding: 10px 0;
    }
    /deep/ td { font-size: 13px; color: #5e6573; padding: 10px 0; }
    /deep/ tr:hover > td { background: #f8faff; }

    .action-btn {
        color: #409eff;
        font-size: 13px;
        padding: 3px 10px;
        border-radius: 3px;
        transition: background 0.15s;
        &:hover { background: #ecf5ff; }
    }
}

.pagination-section { display: flex; justify-content: flex-end; padding: 8px 0 0; }

// ==================== 弹窗 ====================
.add-notification-dialog {
    /deep/ .el-dialog {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    }
    /deep/ .el-dialog__header {
        padding: 18px 24px;
        background: #fff;
        border-bottom: 1px solid #ebeef5;
        .el-dialog__title { font-size: 16px; font-weight: 700; color: #1d2b3a; }
    }
    /deep/ .el-dialog__body {
        padding: 20px 24px;
        max-height: 60vh;
        overflow-y: auto;
        background: #fafbfc;
    }

    // ---- 查看模式详情 ----
    .detail-view {
        .detail-card {
            background: #fff;
            border-radius: 8px;
            margin-bottom: 14px;
            border: 1px solid #ebeef5;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

            &__title {
                padding: 13px 18px;
                font-size: 14px;
                font-weight: 600;
                color: #1d2b3a;
                background: #fafbfc;
                border-bottom: 1px solid #e8ecf1;
                display: flex;
                align-items: center;
                gap: 8px;
                i { color: #409eff; font-size: 16px; }
            }

            .detail-item {
                display: flex;
                padding: 13px 18px;
                border-bottom: 1px solid #f4f5f8;
                align-items: baseline;
                transition: background 0.15s;
                &:hover { background: #fafcff; }
                &:last-child { border-bottom: none; }

                label {
                    min-width: 100px;
                    color: #8c939d;
                    font-size: 13px;
                    flex-shrink: 0;
                }
                span {
                    color: #303133;
                    font-size: 13px;
                    word-break: break-all;
                    flex: 1;
                    line-height: 1.6;
                }
            }

            .detail-text {
                padding: 16px 18px;
                color: #404752;
                font-size: 13px;
                line-height: 1.85;
                white-space: pre-wrap;
                word-break: break-all;
            }

            .detail-file-table { padding: 14px 18px; }
            .detail-empty {
                padding: 32px 16px;
                text-align: center;
                color: #b0b6c1;
                font-size: 13px;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding-top: 16px;
        border-top: 1px solid #ebeef5;
        .el-button { min-width: 90px; border-radius: 6px; font-weight: 500; }
    }
}
</style>
